import { createSlice } from '@reduxjs/toolkit'

// common slice holds generic UI state (e.g., search term)

export const commonSlice = createSlice({
	name: 'common',
	initialState: {
		searchTerm: '',
	},
	reducers: {
		setSearchTerm: (state, action) => {
			state.searchTerm = action.payload
		},
	},
	extraReducers: {},
})

export const { setSearchTerm } = commonSlice.actions

export default commonSlice.reducer
